<template>
    <div class="loading">
        <div class="spinner-wrap">
            <div class="dot"></div>
            <div class="spinner">
                <span class="spike" v-for="n in 12" :key="'n'+n"></span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Spinner'
}
</script>